let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f28kH")).then(() => parcelRequire('5pEhQ'));